import React from "react";
import { Phone } from "lucide-react";

export const MobileFab = () => {
  return (
    <a
      href="tel:684366280"
      data-testid="mobile-fab-call"
      aria-label="Llamar a Norivet 684 36 62 80"
      className="md:hidden fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-violet-600 hover:bg-violet-700 text-white shadow-[0_10px_30px_rgba(124,58,237,0.5)] flex items-center justify-center ring-4 ring-white"
    >
      <span className="absolute inset-0 rounded-full bg-violet-400 animate-ping opacity-60" />
      <Phone className="w-6 h-6 relative" strokeWidth={2.4} />
    </a>
  );
};
